import React from 'react';
import { useSelector } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableRow from '@material-ui/core/TableRow';
import { timeFromNow } from '../../../../@jumbo/utils/dateHelper';
import { Block, CheckCircleOutline, Delete, Edit, Mail, MoreHoriz, Visibility } from '@material-ui/icons';
import CmtDropdownMenu from '../../../../@coremat/CmtDropdownMenu';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { sentMailToUser, updateUserStatus } from '../../../../redux/actions/Fornitori';
import cogoToast from 'cogo-toast';

const useStyles = makeStyles(theme => ({
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.common.dark,
  },
}));

const getUserActions = user => {
  const actions = [
    { action: 'view', label: 'Vedi', icon: <Visibility /> },
    { action: 'edit', label: 'Modifica', icon: <Edit /> },
    { action: 'email', label: 'Email', icon: <Mail /> },
  ];
  /*
  if (user.status === 'active') {
    actions.push({ action: 'suspend', label: 'Sospendi', icon: <Block /> });
  } else {
    actions.push({
      action: 'activate',
      label: 'Riattiva',
      icon: <CheckCircleOutline />,
    });
  }
*/
  actions.push({ action: 'delete', label: 'Cancella', icon: <Delete /> });
  return actions;
};

const UserListRow = ({ row, isSelected, onRowClick, onUserEdit, onUserDelete, onUserView }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const classes = useStyles();
  const dispatch = useDispatch();

  const onUserMenuClick = menu => {
    if (menu.action === 'view') {
      onUserView(row);
    } else if (menu.action === 'edit') {
      if (authUser.livello === '1' || 1) onUserEdit(row);
      else
        cogoToast.error(
          <div>
            <b>Attenzione!</b>
            <div>Non hai i permessi per editare questo fornitore</div>
          </div>,
        );
    } else if (menu.action === 'email') {
      if (row.email) window.open('mailto:' + row.email);
      else dispatch(sentMailToUser());
    } else if (menu.action === 'suspend') {
      dispatch(updateUserStatus({ id: row.userID, status: 'suspended' }));
    } else if (menu.action === 'activate') {
      dispatch(updateUserStatus({ id: row.userID, status: 'active' }));
    } else if (menu.action === 'delete') {
      onUserDelete(row);
    }
  };

  const labelId = `enhanced-table-checkbox-${row.userID}`;
  const isItemSelected = isSelected(row.userID);
  const userActions = getUserActions(row);

  return (
    <TableRow
      hover
      onClick={event => onRowClick(event, row)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.userID}
      selected={isItemSelected}>
      <TableCell padding="checkbox">
        {/*
        <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
      */}
      </TableCell>
      <TableCell component="th" id={labelId} scope="row" padding="none">
        <Box display="flex" alignItems="center">
          <Box mr={{ xs: 4, md: 5 }}>
            <CmtAvatar size={40} src={row.profile_pic} alt={row.ragsoc} />
          </Box>
          <div>
            <Typography className={classes.titleRoot} component="div" variant="h4">
              {row.ragsoc}
            </Typography>
          </div>
        </Box>
      </TableCell>
      <TableCell>{row.piva}</TableCell>
      <TableCell>{row.telefono}</TableCell>
      <TableCell>{row.email}</TableCell>
      <TableCell>{row.referente}</TableCell>
      <TableCell align="center" onClick={event => event.stopPropagation()}>
        <CmtDropdownMenu items={userActions} onItemClick={onUserMenuClick} TriggerComponent={<MoreHoriz />} />
      </TableCell>
    </TableRow>
  );
};

export default React.memo(UserListRow);
